import { Controller } from '@hotwired/stimulus'
import { Tooltip } from 'bootstrap'

export default class extends Controller {
  connect() {
    // On touch devices, hover-triggered tooltips intercept the first tap
    // (e.g. blocking taps on nested buttons like the unassign "x"). Touch
    // has no hover, so disable auto-triggering there.
    const isTouch = window.matchMedia('(pointer: coarse)').matches

    this.tooltip =
      Tooltip.getInstance(this.element) ||
      new Tooltip(this.element, {
        animation: false, // avoid transition callbacks after dispose
        container: 'body',
        trigger: isTouch ? 'manual' : 'hover focus',
      })
  }

  disconnect() {
    this.tooltip?.dispose()
    this.tooltip = null
  }
}
